import { Flex, RadioGroup, Text } from "@radix-ui/themes";
import { t } from "i18next";
import React, { Dispatch, SetStateAction } from "react";
import { Button } from "../../ui/Button";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/Popover";

type Props = {
  filterState: [string[], Dispatch<SetStateAction<string[]>>];
  content: Array<string>;
  categoryName: string;
};

const BooleanCategoryPopover = ({ filterState, categoryName }: Props) => {
  const [open, setOpen] = React.useState(false);
  const [filter, setFilter] = filterState;

  const changeFilter = (value: string) => {
    switch (value) {
      case "with":
        // setFilter(['true'])
        setFilter(['false'])
        break
      case "without":
        // setFilter(["true", "false"])
        setFilter(["true", "false"])
        break
      case "all":
        setFilter(['true'])
        break
      default:
        // setFilter(["true", "false"])
        setFilter(['false'])
        break
    }
  };

  const getDefaultValue = () => {
    if (filter.includes('true')) {
      if (filter.includes("false")) return "all"
      else return "with"
    }
    else return "without"
  }
  
  return (
    <Button size={"xs"} variant={"outline"} className="gap-2" onClick={() => changeFilter(getDefaultValue())}>
      <span>{getDefaultValue() === "all" ? t('all') : getDefaultValue() === "with" ? t("sensors_connected") : t("sensors_disconnected")}</span>
    </Button>
  );
};

export default BooleanCategoryPopover;
